/* @flow */
// typecheck: ignore file
import KeyConstants from 'constants/KeyConstants';
import React from 'react';

const stack = [];

const handleDocumentKeyDown: KeyboardEventListener = (event) => {
  if (event.keyCode === KeyConstants.ESCAPE) {
    let l = stack.length;
    while (l--) {
      const layer = stack[l];
      if (layer && layer.props.hideOnEscape) {
        if (!layer.props.onRequestHide) {
          console.error('component has hideOnEscape without onRequestHide', layer.displayName);
          continue;
        }
        event.preventDefault();
        layer.props.onRequestHide();
        break;
      }
    }
  }
};

const LayerHideOnEscape = {
  propTypes: {
    hideOnEscape: React.PropTypes.bool,
    onRequestHide: React.PropTypes.func,
  },

  getDefaultProps() {
    return {
      hideOnEscape: true,
    };
  },

  componentDidMount() {
    if (stack.length === 0) {
      document.addEventListener('keydown', handleDocumentKeyDown, false);
    }
    stack.push(this);
  },

  componentWillUnmount() {
    const index = stack.indexOf(this);
    if (index >= 0) {
      stack.splice(index, 1);

      if (stack.length === 0) {
        document.removeEventListener('keydown', handleDocumentKeyDown, false);
      }
    }
  },
};

export default LayerHideOnEscape;



// WEBPACK FOOTER //
// ./src/components/mixins/LayerHideOnEscape.js